/**
 * What each stored enum value reads as, and the color of the dot beside it.
 *
 * Keyed by the last segment of a path, because every collection that stores a
 * `status` or a `standing` stores the same values under it: `status`,
 * `billingInfo.standing` and `operationInfo.billingInfo.standing` all read
 * from here. The list, the detail panel and the relationship rows take their
 * wording from this one place, so a value cannot read one way in the table and
 * another way beside it.
 */
export const ENUM_META = {
    status: {
        active: { label: 'Active', color: 'var(--p-status-success)' },
        suspended: { label: 'Suspended', color: 'var(--p-status-warning)' },
        retired: { label: 'Retired', color: 'var(--p-text-muted-color)' }
    },
    standing: {
        current: { label: 'Current', color: 'var(--p-status-success)' },
        past_due: { label: 'Past due', color: 'var(--p-status-warning)' },
        delinquent: { label: 'Delinquent', color: 'var(--p-status-danger)' }
    }
}

/**
 * What a value reads as. One this map does not name still reads as words:
 * `past_due` becomes "Past due" rather than the stored form.
 */
export function enumLabel(leaf, value) {
    const known = ENUM_META[leaf]?.[value]
    if (known) {
        return known.label
    }
    const words = String(value).replace(/[_-]+/g, ' ').trim()
    return words.charAt(0).toUpperCase() + words.slice(1)
}

/** The `{ label, color }` for every value a field declares, for the layout's formatter. */
export function enumMetaFor(leaf, values) {
    const meta = {}
    for (const value of values ?? []) {
        meta[value] = { label: enumLabel(leaf, value), color: ENUM_META[leaf]?.[value]?.color ?? null }
    }
    return meta
}
